import React from "react";
import TopBanner from "../components/banner/topBanner";
import { Banners } from "../components/data";
import CardsBlock from "../components/blocks/cardsBlock";
import { cardsData6, cardsData7} from '../components/data';

export default function Logistic() {
    return(
        <div className="Logistic">
            <TopBanner title={Banners[3].title} />
            <div className="container">
                <CardsBlock cards={ cardsData6 }/>
            </div>
            <div className="container">
                <h3 className="textBlue">Вы сможете</h3>
                <CardsBlock cards={ cardsData7 } />
            </div>
        </div>
    )
}